import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Tag from "./Tag";
import { formatCategory } from '../../utils/string';

function TagList({ tags, categories = [], className }) {
 const listClassName = classnames("tagList", className);

 return (
  <ul className={listClassName}>
   {categories.map((category) => (
    <Tag isCategory key={category} name={formatCategory(category)} to={`/categories/${category}`} />
   ))}

   {tags.map((tag) => (
    <Tag key={tag} name={tag} to={`/tags/${tag}`} />
   ))}
  </ul>
 );
}

TagList.propTypes = {
 tags: PropTypes.arrayOf(PropTypes.string),
 categories: PropTypes.arrayOf(PropTypes.string),
 className: PropTypes.string,
};

export default TagList;
